<template>
  <v-card>
    <v-card-title class="pb-0">
      <div class="mr-2">
        {{ title }}
      </div>
      <div v-if="items.length">
        ({{ items.length }})
      </div>
    </v-card-title>
    <v-card-text>
      <v-text-field v-model="search"
                    placeholder="Search"
                    dense
                    hide-details
                    class="pt-0 mt-0">
      </v-text-field>
    </v-card-text>
    <v-virtual-scroll :height="cardHeight"
                      :item-height="itemHeight"
                      :items="filteredItems">
      <template v-slot:default="{index, item}">
        <template>
          <v-list-item :key="item.id"
                       dense>
            <v-list-item-content class="my-1 py-0">
              <v-checkbox v-model="form[field]"
                          :value="item.id"
                          hide-details
                          dense
                          class="my-0 py-0"
                          style="width: 100%; overflow: hidden;">
                <template v-slot:label>
                  <div>
                    <div class="text-body-2 text-truncate">
                      {{ item[itemText] }}
                    </div>
                    <div class="text-caption">
                      {{ item[itemValue] }}
                    </div>
                  </div>
                </template>
              </v-checkbox>
            </v-list-item-content>
            <v-list-item-icon class="my-1 py-0">
              <v-btn @click.prevent="copyText(item['id'])"
                     icon>
                <v-icon>
                  fal fa-copy
                </v-icon>
              </v-btn>
            </v-list-item-icon>
          </v-list-item>
          <v-divider></v-divider>
        </template>
      </template>
    </v-virtual-scroll>
  </v-card>
</template>
<script>
import {mapGetters} from 'vuex';
import {forOwn, toString} from 'lodash';
import clipboardService from '../../../../../ml/services/clipboardService';

export default {
  props: {
    form: {
      type: Object,
      required: false,
    },
    field: {
      type: String,
      required: false,
    },
    cardHeight: {
      type: Number,
      default: 200,
    },
    items: {
      type: Array,
      required: true,
    },
    itemText: {
      type: String,
      default: 'name__v',
    },
    itemValue: {
      type: String,
      default: 'id',
    },
    itemHeight: {
      type: Number,
      default: 50,
    },
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      error: null,
      search: null,
    }
  },
  computed: {
    ...mapGetters([
      'team',
      'user',
    ]),
    cleanSearch() {
      return toString(this.search).trim().toLowerCase();
    },
    filteredItems() {
      if (this.cleanSearch) {
        return this.items.filter(item => {
          let found = false;
          forOwn(item, (value, key) => {
            const strValue = toString(value).trim().toLowerCase();
            if (strValue && strValue.includes(this.cleanSearch)) {
              found = true;
            }
          })
          return found;
        })
      }
      return this.items;
    },
  },
  methods: {
    copyText(text) {
      clipboardService.copy(text, false)
        .then(() => {
          this.$toast(`Copied ${text} to your clipboard`);
        })
    },
  }
}
</script>
